import { PageTitle } from '#app/components/layout/page-title.tsx'

export default function ImpressumPage() {
	return (
		<>
			<PageTitle titleText="Impressum" />
			<div className="container">
				<div className="flex flex-col gap-8">
					<p>
						<h3 className="text-pcteal-700 font-bold">Publicare GmbH</h3>
						An der Trauner Kreuzung 1<br /> 4061 Pasching
						<br /> Österreich
					</p>
					<p>
						Unternehmensgegenstand: Handel mit medizinischen Hilfsmitteln
						<br />
						UID-Nummer: ATU56111601 <br />
						Firmenbuchnummer: FN 225286d
						<br />
						Firmenbuchgericht: Landesgericht Linz
						<br />
						Firmensitz: 4061 Pasching
						<br />
					</p>
					<p>
						<h3 className="text-pcteal-700 font-bold">Kontaktdaten</h3>
						Telefon: <a href="tel:0043722970560">+43 (0)7229/70 560</a>
						<br />
						Fax: <a href="tel:004372297056060">+43 (0)7229/70 560-60</a>
						<br />
						E-Mail: <a href="mailto:info@publicare.at">info@publicare.at</a>
						<br />
					</p>
					<p>
						Geschäftsführer: Herr Wolfgang Baumgartner <br />
						Mitglied der WKOÖ
						<br />
						Gewerbebehörde: Bezirkshauptmannschaft Linz-Land
					</p>
				</div>
			</div>
		</>
	)
}
